(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_plate"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-custom-plates')) {
  customElements.define('lp-custom-plates', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.files = [];
      this.previewUrls = [];
      this.busy = false;
      this.checkingFiles = false;
      this.allowSubmission = false;
      const form = this.querySelector('.cp-form');
      if (!form) return;
      this.form = form;
      this.button = this.querySelector('.cp-submit');
      this.buttonLabel = this.querySelector('[data-cp-submit-label]');
      this.buttonText = this.buttonLabel?.textContent;
      this.fileInput = this.querySelector('[data-cp-images]');
      this.classList.add('cp-js-ready');
      this.linksInput = this.querySelector('[data-cp-image-links]');
      this.status = this.querySelector('[data-cp-upload-status]');
      const sync = () => {
        const business = this.querySelector('[data-cp-type="business"]')?.checked;
        const company = this.querySelector('[data-cp-company]');
        if (company) {
          company.hidden = !business;
          const input = company.querySelector('input');
          input.disabled = !business;
          input.required = Boolean(business);
          company.querySelector('[data-cp-company-required]').hidden = !business;
        }
        const customSize = this.querySelector('[data-cp-size]')?.value === 'Sondergröße';
        const dimensions = this.querySelector('[data-cp-dimensions]');
        if (dimensions) {
          dimensions.hidden = !customSize;
          dimensions.querySelector('input').disabled = !customSize;
        }
      };
      form.addEventListener('change', sync, { signal });
      form.addEventListener('reset', () => {
        this.files = [];
        this.renderImages();
        this.setStatus('');
        queueMicrotask(sync);
      }, { signal });
      form.addEventListener('invalid', event => {
        const details = event.target.closest('details');
        if (details) details.open = true;
      }, { capture: true, signal });
      form.addEventListener('submit', event => {
        if (this.allowSubmission) { this.allowSubmission = false; return; }
        if (this.busy || this.checkingFiles) {
          event.preventDefault();
          return;
        }
        if (this.files.length) {
          event.preventDefault();
          void this.uploadAndSubmit();
        }
      }, { signal });
      this.fileInput?.addEventListener('change', () => {
        const incoming = [...this.fileInput.files];
        this.fileInput.value = '';
        void this.addImages(incoming);
      }, { signal });
      const drop = this.querySelector('.cp-upload-drop');
      if (drop) {
        ['dragenter', 'dragover'].forEach(type => drop.addEventListener(type, event => {
          event.preventDefault();
          drop.classList.add('cp-is-dragging');
        }, { signal }));
        drop.addEventListener('dragleave', event => {
          if (!drop.contains(event.relatedTarget)) drop.classList.remove('cp-is-dragging');
        }, { signal });
        drop.addEventListener('drop', event => {
          event.preventDefault();
          drop.classList.remove('cp-is-dragging');
          void this.addImages([...event.dataTransfer.files]);
        }, { signal });
      }
      window.addEventListener('pageshow', () => {
        this.busy = false;
        if (this.button) this.button.disabled = false;
        if (this.buttonLabel) this.buttonLabel.textContent = this.buttonText;
        sync();
      }, { signal });
      sync();
      const result = this.querySelector('[data-cp-status]');
      if (result && !window.Shopify?.designMode) result.focus();
    }
    setStatus(message, error = false) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.toggle('cp-upload-status--error', error);
    }
    async addImages(incoming) {
      if (this.busy || this.checkingFiles || !incoming.length) return;
      const known = new Set(this.files.map(file => `${file.name}:${file.size}:${file.lastModified}`));
      const candidates = incoming.filter(file => {
        const key = `${file.name}:${file.size}:${file.lastModified}`;
        if (known.has(key)) return false;
        known.add(key);
        return true;
      });
      if (this.files.length + candidates.length > 3) {
        this.setStatus('Bitte wähle insgesamt höchstens 3 Bilder aus.', true);
        return;
      }
      this.checkingFiles = true;
      if (this.button) this.button.disabled = true;
      this.setStatus('Bilder werden geprüft …');
      try {
        const verified = [];
        for (const file of candidates) {
          if (!file.size || file.size > 5 * 1024 * 1024) throw new Error('Jedes Bild darf höchstens 5 MB groß sein und muss eine gültige Bilddatei sein.');
          const ext = file.name.split('.').pop().toLowerCase();
          const header = new Uint8Array(await file.slice(0, 16).arrayBuffer());
          const ascii = (start, end) => String.fromCharCode(...header.slice(start, end));
          let mime = '';
          if (header[0] === 137 && ascii(1, 4) === 'PNG' && header[4] === 13 && header[5] === 10 && header[6] === 26 && header[7] === 10 && ext === 'png') mime = 'image/png';
          if (header[0] === 255 && header[1] === 216 && header[2] === 255 && ['jpg', 'jpeg'].includes(ext)) mime = 'image/jpeg';
          if (['GIF87a', 'GIF89a'].includes(ascii(0, 6)) && ext === 'gif') mime = 'image/gif';
          if (ascii(0, 4) === 'RIFF' && ascii(8, 12) === 'WEBP' && ext === 'webp') mime = 'image/webp';
          if (!mime) throw new Error('Bitte lade ausschließlich echte PNG-, JPG-, JPEG-, WEBP- oder GIF-Bilder hoch. Andere Dateiformate werden nicht angenommen.');
          if (window.createImageBitmap) {
            let bitmap;
            try { bitmap = await createImageBitmap(file); }
            catch { throw new Error('Ein Bild konnte nicht geöffnet werden. Bitte wähle eine unbeschädigte Bilddatei.'); }
            const tooLarge = bitmap.width * bitmap.height > 40000000;
            bitmap.close();
            if (tooLarge) throw new Error('Ein Bild hat eine zu hohe Auflösung. Bitte verkleinere es auf höchstens 40 Megapixel.');
          }
          verified.push(new File([file], file.name, { type: mime, lastModified: file.lastModified }));
        }
        if (this.controller.signal.aborted) return;
        this.files.push(...verified);
        this.renderImages();
        this.setStatus(this.files.length ? `${this.files.length} ${this.files.length === 1 ? 'Bild ausgewählt' : 'Bilder ausgewählt'}. Die Bilder werden beim Absenden übertragen.` : '');
      } catch (error) {
        this.setStatus(error.message, true);
      } finally {
        this.checkingFiles = false;
        if (this.button && !this.busy) this.button.disabled = false;
      }
    }
    renderImages() {
      this.previewUrls?.forEach(url => URL.revokeObjectURL(url));
      this.previewUrls = [];
      const list = this.querySelector('[data-cp-previews]');
      if (!list) return;
      list.replaceChildren();
      if (this.linksInput) { this.linksInput.value = ''; this.linksInput.disabled = true; }
      this.files.forEach((file, index) => {
        const item = document.createElement('li');
        const img = document.createElement('img');
        const url = URL.createObjectURL(file);
        this.previewUrls.push(url);
        img.src = url;
        img.alt = `Vorschau: ${file.name}`;
        const description = document.createElement('div');
        const name = document.createElement('strong');
        name.textContent = file.name;
        const size = document.createElement('small');
        size.textContent = file.size < 1024 * 1024 ? `${Math.ceil(file.size / 1024)} KB` : `${(file.size / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
        description.append(name, size);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cp-remove-image';
        remove.textContent = '×';
        remove.setAttribute('aria-label', `${file.name} entfernen`);
        remove.addEventListener('click', () => {
          if (this.busy) return;
          this.files.splice(index, 1);
          this.renderImages();
          this.setStatus(this.files.length ? `${this.files.length} ${this.files.length === 1 ? 'Bild ausgewählt' : 'Bilder ausgewählt'}.` : '');
          this.fileInput.focus();
        }, { signal: this.controller.signal });
        item.append(img, description, remove);
        list.append(item);
      });
    }
    async uploadAndSubmit() {
      const endpointText = this.dataset.uploadEndpoint?.trim();
      if (!endpointText) {
        this.setStatus('Die Bildübertragung ist derzeit nicht verfügbar. Entferne die Bilder und nutze einen Referenzlink, oder versuche es später erneut.', true);
        this.status.scrollIntoView({ block: 'nearest' });
        return;
      }
      this.busy = true;
      this.button.disabled = true;
      this.buttonLabel.textContent = 'Bilder werden übertragen …';
      this.setStatus('Bitte kurz warten. Deine Bilder werden hochgeladen.');
      try {
        const endpoint = new URL(endpointText, window.location.href);
        if (endpoint.protocol !== 'https:' && endpoint.origin !== window.location.origin) throw new Error('Die Bildübertragung ist derzeit nicht verfügbar. Bitte versuche es später erneut.');
        const payload = new FormData();
        this.files.forEach(file => payload.append('images', file, file.name));
        const response = await fetch(endpoint.href, { method: 'POST', body: payload, signal: AbortSignal.any([this.controller.signal, AbortSignal.timeout(45000)]) });
        if (!response.ok) throw new Error('Die Bilder konnten nicht übertragen werden. Bitte versuche es erneut oder entferne die Bilder. Deine Anfrage wurde noch nicht gesendet.');
        const data = await response.json();
        if (!Array.isArray(data.images) || data.images.length !== this.files.length) throw new Error('Es wurden nicht alle Bilder übertragen. Bitte versuche es erneut. Deine Anfrage wurde noch nicht gesendet.');
        const links = data.images.map((image, index) => {
          if (typeof image?.url !== 'string' || !image.url.trim()) throw new Error('Die Bildübertragung konnte nicht abgeschlossen werden. Bitte versuche es erneut.');
          const url = new URL(image.url, endpoint.href);
          if ((url.protocol !== 'https:' && url.origin !== window.location.origin) || url.username || url.password) throw new Error('Die Bildübertragung konnte nicht abgeschlossen werden. Bitte versuche es erneut.');
          return `${this.files[index].name}\n${url.href}`;
        });
        this.linksInput.value = links.join('\n\n');
        this.linksInput.disabled = false;
        this.setStatus('Bilder hochgeladen. Deine Anfrage wird jetzt gesendet.');
        this.button.disabled = false;
        this.buttonLabel.textContent = this.buttonText;
        this.allowSubmission = true;
        this.form.requestSubmit(this.button);
      } catch (error) {
        this.allowSubmission = false;
        this.linksInput.value = '';
        this.linksInput.disabled = true;
        if (!this.controller.signal.aborted) this.setStatus(error.name === 'TimeoutError' ? 'Die Übertragung dauert zu lange. Bitte versuche es erneut. Deine Anfrage wurde noch nicht gesendet.' : error.message, true);
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.buttonLabel.textContent = this.buttonText;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.previewUrls?.forEach(url => URL.revokeObjectURL(url));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glass-media-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.gmbInitialized === 'true') return;
      root.dataset.gmbInitialized = 'true';

      const video = root.querySelector('.glass-media-banner__video');
      if (!video) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const usesDataSaver = Boolean(connection && connection.saveData);
      const usesVerySlowConnection = Boolean(
        connection && typeof connection.effectiveType === 'string' && /(^|-)2g$/.test(connection.effectiveType)
      );

      if (reduceMotion.matches || usesDataSaver || usesVerySlowConnection) {
        video.removeAttribute('autoplay');
        return;
      }

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let activeSource = '';
      let isNearViewport = !('IntersectionObserver' in window);
      let loadScheduled = false;
      let sourceRequestId = 0;
      let observer = null;

      const chooseSource = (template) => {
        const candidates = Array.from(template.content.querySelectorAll('source[data-src]'))
          .map((source) => ({
            src: source.dataset.src,
            width: Number(source.dataset.width) || 0,
          }))
          .filter((candidate) => candidate.src)
          .sort((a, b) => a.width - b.width);

        if (!candidates.length) return null;

        const bannerWidth = Math.max(root.getBoundingClientRect().width, 320);
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5);
        const desiredWidth = Math.min(Math.ceil(bannerWidth * pixelRatio), 2200);

        return candidates.find((candidate) => candidate.width >= desiredWidth) || candidates[candidates.length - 1];
      };

      const playVideo = () => {
        if (!isNearViewport || document.hidden || !root.classList.contains('is-video-ready')) return;
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      };

      const loadVideo = () => {
        if (!isNearViewport) return;

        const requestedMode = mobileQuery.matches ? 'mobile' : 'desktop';
        const fallbackMode = requestedMode === 'mobile' ? 'desktop' : 'mobile';
        const template =
          root.querySelector(`[data-gmb-video-template="${requestedMode}"]`) ||
          root.querySelector(`[data-gmb-video-template="${fallbackMode}"]`);

        if (!template) return;

        const selectedSource = chooseSource(template);
        if (!selectedSource) return;
        if (activeSource === selectedSource.src) {
          playVideo();
          return;
        }

        activeSource = selectedSource.src;
        sourceRequestId += 1;
        const currentRequestId = sourceRequestId;

        root.classList.remove('is-video-ready');
        video.pause();
        video.removeAttribute('src');
        video.load();

        video.addEventListener(
          'canplay',
          () => {
            if (currentRequestId !== sourceRequestId) return;
            root.classList.add('is-video-ready');
            playVideo();
          },
          { once: true }
        );

        video.addEventListener(
          'error',
          () => {
            if (currentRequestId !== sourceRequestId) return;
            root.classList.remove('is-video-ready');
          },
          { once: true }
        );

        video.src = selectedSource.src;
        video.load();
      };

      const scheduleLoad = () => {
        if (!isNearViewport || loadScheduled) return;
        loadScheduled = true;

        const run = () => {
          loadScheduled = false;
          if (isNearViewport) loadVideo();
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(run, { timeout: 900 });
        } else {
          window.setTimeout(run, 180);
        }
      };

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isNearViewport = entry.isIntersecting;
              if (isNearViewport) {
                scheduleLoad();
                playVideo();
              } else {
                video.pause();
              }
            });
          },
          {
            rootMargin: '350px 0px',
            threshold: 0.01,
          }
        );
        observer.observe(root);
      } else {
        scheduleLoad();
      }

      const handleModeChange = () => {
        if (isNearViewport) scheduleLoad();
      };

      const handleVisibilityChange = () => {
        if (document.hidden) {
          video.pause();
        } else {
          playVideo();
        }
      };

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleModeChange);
      } else {
        mobileQuery.addListener(handleModeChange);
      }
      document.addEventListener('visibilitychange', handleVisibilityChange);

      root.gmbCleanup = () => {
        sourceRequestId += 1;
        isNearViewport = false;
        if (observer) observer.disconnect();
        video.pause();

        if (mobileQuery.removeEventListener) {
          mobileQuery.removeEventListener('change', handleModeChange);
        } else {
          mobileQuery.removeListener(handleModeChange);
        }
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    };

    const initializeAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-glass-media-banner]')) initialize(scope);
      scope.querySelectorAll('[data-glass-media-banner]').forEach(initialize);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const roots = [];
      if (event.target.matches && event.target.matches('[data-glass-media-banner]')) roots.push(event.target);
      event.target.querySelectorAll('[data-glass-media-banner]').forEach((root) => roots.push(root));
      roots.forEach((root) => {
        if (typeof root.gmbCleanup === 'function') root.gmbCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luminus-media-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luminus-media-wall')) {
    customElements.define(
      'luminus-media-wall',
      class LuminusMediaWall extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.grid = this.querySelector('[data-grid]');
          this.toggle = this.querySelector('[data-toggle]');
          this.toggleWrap = this.querySelector('[data-toggle-wrap]');
          this.veil = this.querySelector('[data-veil]');
          this.items = Array.from(this.querySelectorAll('[data-item]')).filter((item) => item.querySelector('[data-open]'));
          this.dialog = this.querySelector('[data-dialog]');
          this.dialogMedia = this.querySelector('[data-dialog-media]');
          this.dialogTitle = this.querySelector('[data-dialog-title]');
          this.dialogCaption = this.querySelector('[data-dialog-caption]');
          this.dialogLink = this.querySelector('[data-dialog-link]');
          this.currentIndex = 0;
          this.lastFocus = null;
          this.previousOverflow = '';

          this.onToggle = this.onToggle.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.updateOverflow = this.updateOverflow.bind(this);

          if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
          this.querySelectorAll('[data-open]').forEach((button, index) => {
            button.addEventListener('click', () => this.openDialog(index));
          });
          this.querySelectorAll('[data-close]').forEach((button) => {
            button.addEventListener('click', () => this.closeDialog());
          });
          this.querySelector('[data-prev]')?.addEventListener('click', () => this.showItem(this.currentIndex - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.showItem(this.currentIndex + 1));

          this.resizeObserver = new ResizeObserver(this.updateOverflow);
          if (this.grid) this.resizeObserver.observe(this.grid);
          requestAnimationFrame(this.updateOverflow);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          document.removeEventListener('keydown', this.onKeydown);
          if (this.dialog && !this.dialog.hidden) this.closeDialog(false);
        }

        getCollapsedHeight() {
          const property = window.matchMedia('(min-width: 750px)').matches
            ? '--lmw-collapse-desktop'
            : '--lmw-collapse-mobile';
          return parseFloat(getComputedStyle(this).getPropertyValue(property)) || 0;
        }

        updateOverflow() {
          if (!this.grid || !this.toggleWrap) return;
          if (this.classList.contains('is-expanded')) {
            this.grid.style.maxHeight = `${this.grid.scrollHeight}px`;
            return;
          }
          const hasOverflow = this.grid.scrollHeight > this.getCollapsedHeight() + 2;
          this.toggleWrap.hidden = !hasOverflow;
          if (this.veil) this.veil.hidden = !hasOverflow;
        }

        onToggle() {
          const expanded = !this.classList.contains('is-expanded');
          this.classList.toggle('is-expanded', expanded);
          this.toggle.setAttribute('aria-expanded', String(expanded));
          this.toggle.querySelector('[data-toggle-label]').textContent = expanded
            ? this.dataset.lessLabel
            : this.dataset.moreLabel;

          if (expanded) {
            this.grid.style.maxHeight = `${this.grid.scrollHeight}px`;
          } else {
            this.grid.style.maxHeight = `${this.grid.scrollHeight}px`;
            requestAnimationFrame(() => {
              this.grid.style.maxHeight = `${this.getCollapsedHeight()}px`;
            });
            this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          }
        }

        openDialog(index) {
          if (!this.dialog || !this.items.length) return;
          this.lastFocus = document.activeElement;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.hidden = false;
          this.showItem(index);
          document.addEventListener('keydown', this.onKeydown);
          requestAnimationFrame(() => this.querySelector('.lmw__dialog-close')?.focus());
        }

        closeDialog(restoreFocus = true) {
          if (!this.dialog || this.dialog.hidden) return;
          this.stopCurrentVideo();
          this.dialog.hidden = true;
          this.dialogMedia.replaceChildren();
          document.documentElement.style.overflow = this.previousOverflow;
          document.removeEventListener('keydown', this.onKeydown);
          if (restoreFocus && this.lastFocus instanceof HTMLElement) this.lastFocus.focus();
        }

        stopCurrentVideo() {
          const video = this.dialogMedia?.querySelector('video');
          if (video) {
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
            video.load();
          }
        }

        showItem(index) {
          if (!this.items.length) return;
          this.currentIndex = (index + this.items.length) % this.items.length;
          const item = this.items[this.currentIndex];
          const template = item.querySelector('[data-media-template]');
          const copy = item.querySelector('[data-copy]');

          this.stopCurrentVideo();
          this.dialogMedia.replaceChildren(template.content.cloneNode(true));

          const title = copy?.querySelector('[data-title]');
          const caption = copy?.querySelector('[data-caption]');
          const link = copy?.querySelector('[data-link]');
          this.dialogTitle.textContent = title?.textContent.trim() || `${this.currentIndex + 1} / ${this.items.length}`;
          this.dialogCaption.innerHTML = caption?.innerHTML || '';
          this.dialogCaption.hidden = !caption;

          if (link) {
            this.dialogLink.href = link.href;
            this.dialogLink.textContent = link.textContent;
            this.dialogLink.classList.add('is-visible');
          } else {
            this.dialogLink.removeAttribute('href');
            this.dialogLink.textContent = '';
            this.dialogLink.classList.remove('is-visible');
          }

          const video = this.dialogMedia.querySelector('video');
          video?.play().catch(() => {});
        }

        onKeydown(event) {
          if (event.key === 'Escape') this.closeDialog();
          if (event.target.tagName !== 'VIDEO') {
            if (event.key === 'ArrowLeft') this.showItem(this.currentIndex - 1);
            if (event.key === 'ArrowRight') this.showItem(this.currentIndex + 1);
          }

          if (event.key === 'Tab' && !this.dialog.hidden) {
            const focusable = Array.from(
              this.dialog.querySelectorAll('button:not([hidden]), a[href], video[controls]')
            ).filter((element) => !element.hasAttribute('disabled') && element.offsetParent !== null);
            if (!focusable.length) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner_logos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-partner-logos')) {
  customElements.define('lp-partner-logos', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.viewport = this.querySelector('[data-plp-viewport]');
      this.source = this.querySelector('[data-plp-source]');
      this.details = this.querySelector('[data-plp-details]');
      if (!this.viewport || !this.source) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.details.addEventListener('toggle', () => this.classList.toggle('plp-paused', this.details.open), options);
      this.addEventListener('shopify:block:select', () => {
        this.details.open = true;
        this.classList.add('plp-paused');
      }, options);
      this.motion.addEventListener('change', () => this.build(), options);
      this.observer = new ResizeObserver(entries => {
        const width = Math.round(entries[0].contentRect.width);
        if (width !== this.observedWidth) {
          this.observedWidth = width;
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.build());
        }
      });
      this.observer.observe(this);
      this.build();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    copyItem(item) {
      const copy = item.cloneNode(true);
      [copy, ...copy.querySelectorAll('*')].forEach(node => {
        [...node.attributes].forEach(attribute => {
          if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) node.removeAttribute(attribute.name);
        });
        if (node.matches('a, button, input, select, textarea, [tabindex]')) node.tabIndex = -1;
        if (node.matches('img')) node.loading = 'eager';
      });
      return copy;
    }
    build() {
      const items = [...this.source.children];
      this.viewport.replaceChildren();
      if (this.motion.matches || !items.length || this.clientWidth === 0) {
        this.classList.remove('plp-enhanced');
        this.viewport.hidden = true;
        this.details.open = true;
        return;
      }
      const wasEnhanced = this.classList.contains('plp-enhanced');
      this.classList.add('plp-enhanced');
      this.viewport.hidden = false;
      if (!wasEnhanced) this.details.open = false;
      const track = document.createElement('div');
      track.className = 'plp-track';
      const group = document.createElement('div');
      group.className = 'plp-group';
      items.forEach(item => group.append(this.copyItem(item)));
      track.append(group);
      this.viewport.append(track);
      const initialWidth = group.getBoundingClientRect().width;
      if (!initialWidth) return;
      const repeat = Math.ceil(this.viewport.clientWidth / initialWidth);
      for (let i = 1; i < repeat; i++) items.forEach(item => group.append(this.copyItem(item)));
      const width = group.getBoundingClientRect().width;
      const speed = Math.max(20, Math.min(100, Number(this.dataset.speed) || 40));
      track.style.setProperty('--plp-travel', `${width}px`);
      track.style.setProperty('--plp-duration', `${width / speed}s`);
      track.append(group.cloneNode(true));
      this.classList.toggle('plp-paused', this.details.open);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-triple-glass"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-usp-video')) {
    customElements.define('lp-usp-video', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        if (this.dataset.autoplay === 'true') {
          this.video.controls = false;
          this.video.tabIndex = -1;
          this.video.disablePictureInPicture = true;
          this.video.disableRemotePlayback = true;
          this.addEventListener('contextmenu', event => event.preventDefault(), { signal });
        }
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.resume = false;
        this.systemPause = false;
        this.hasPlayed = false;
        this.video.muted = true;
        this.video.addEventListener('play', () => { this.hasPlayed = true; this.resume = true; }, { signal });
        this.video.addEventListener('pause', () => {
          if (this.systemPause) this.systemPause = false;
          else this.resume = false;
        }, { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.resume = false; this.pauseVideo(); }
          else this.syncPlayback();
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
            this.syncPlayback();
          }, { threshold: .15 });
          this.observer.observe(this.video);
        }
      }
      syncPlayback() {
        if (!this.inView || document.hidden) { this.pauseVideo(); return; }
        const autoStart = this.dataset.autoplay === 'true' && !this.hasPlayed && !this.motion.matches && !navigator.connection?.saveData;
        if ((this.resume || autoStart) && this.video.paused) this.video.play().catch(() => { this.resume = false; });
      }
      pauseVideo() {
        if (!this.video?.paused) { this.systemPause = true; this.video.pause(); }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
